module.exports = __webpack_public_path__ + "media/images/logos/facebook-light-3b8bbfff282dba46b80ab1e9913e0d5d.svg";